import request from "@/utils/request";

// export function subjectAllApi(that, query, func) {
//   query = that.$qs.stringify(query, { arrayFormat: "repeat" });
//   request({
//     url: "/v1.0/iwrs/subject/all?" + query,
//     method: "get"
//   })
//     .then(res => {
//       if (res && res.success) {
//         func(res);
//       } else {
//         that.$message.error(res.msg);
//       }
//     })
//     .catch(res => {
//       console.log(res.msg);
//       that.$message.error("请求失败");
//     });
// }
export function subjectAllApi(that,query) {
  query = that.$qs.stringify(query, { arrayFormat: "repeat" });
  return request({
    url: "/v1.0/iwrs/subject/all?" + query,
    method: "get"
  })
}

// 详情，获取最近备注也调用这个接口
export function subjectDetailApi(that, query, func) {
  request({
    url: "/v1.0/iwrs/subject/detail",
    method: "get",
    params: query
  })
    .then(res => {
      if (res && res.success) {
        func(res);
      } else {
        that.$message.error(res.msg);
      }
    })
    .catch(res => {
      console.log(res.msg);
      that.$message.error("请求失败");
    });
}

// 变更访视
export function subjectGoNextVisit(that, data, func) {
  request({
    url: "/v1.0/iwrs/subject/go_next_visit",
    method: "post",
    data
  })
    .then(res => {
      if (res && res.success) {
        that.$message({
          message: res.msg,
          type: "success"
        });
        func(res);
      } else {
        that.$message.error(res.msg);
      }
    })
    .catch(res => {
      console.log("错误日志", res);
      that.$message.error("请求失败");
    });
}

// 查看（访视变更记录）
export function subjectLogs(that, query, func) {
  request({
    url: "/v1.0/iwrs/subject/logs",
    method: "get",
    params: query
  })
    .then(res => {
      if (res && res.success) {
        func(res);
      } else {
        that.$message.error(res.msg);
      }
    })
    .catch(res => {
      console.log("错误日志", res);
      that.$message.error("请求失败");
    });
}

export function subjectRemarks(that, data, func) {
  request({
    url: "/v1.0/iwrs/subject/remarks",
    method: "post",
    data
  })
    .then(res => {
      if (res && res.success) {
        that.$message({
          message: res.msg,
          type: "success"
        });
        func(res);
      } else {
        that.$message.error(res.msg);
      }
    })
    .catch(res => {
      console.log("错误日志", res);
      that.$message.error("请求失败");
    });
}

// 邮箱导出
export function subjectExportApi(data) {
  return request({
    url: "/v1.0/iwrs/subject/export",
    method: "post",
    data
  });
}
// export function subjectExportApi(that, data, func) {
//   request({
//     url: "/v1.0/iwrs/subject/export",
//     method: "post",
//     data
//   })
//     .then(res => {
//       if (res && res.errcode===200) {
//         that.$message({
//           message: res.errmsg,
//           type: "success"
//         });
//         func(res);
//       } else {
//         that.$message.error(res.errmsg);
//       }
//     })
//     .catch(res => {
//       console.log("错误日志", res);
//       that.$message.error("请求失败");
//     }).finally(()=>{
//       that.loading=false;
//     })
// }

// 新增受试者时根据选择的单位获取前缀和后缀
export function subjectNextInforApi(that, data, func) {
  request({
    url: "/v1.0/iwrs/subject/next_infor",
    method: "post",
    data
  })
    .then(res => {
      if (res && res.success) {
        func(res);
      } else {
        that.$message.error(res.msg);
      }
    })
    .catch(res => {
      console.log("错误日志", res);
      that.$message.error("请求失败");
    });
}

// 新增受试者
export function subjectAddApi(data, projectId) {
  return request({
    url: `/v1.0/iwrs/subject/add?project_id=${projectId}`,
    method: "post",
    data
  })
}

export function subjectLoading(params) {
  return request({
    url: "/v1.0/iwrs/subject/add_loading",
    method: "get",
    params
  })
}

// ----------下面是杨宁之前的代码-------

export function subjectList(query) {
  return request({
    url: "/v1.0/iwrs/subject/all?" + query,
    method: "get",
    params: query
  });
}

// 新增受试者
export function add(data) {
  return request({
    url: "/v1.0/iwrs/subject/add",
    method: "post",
    data
  });
}

// 返回指定中心的所有主要研究者
export function mainUser(query) {
  return request({
    url: "/v1.0/iwrs/project_user/all_main_doctor",
    method: "get",
    params: query
  });
}

// 所有脱落受试者，分页
export function allFall(query) {
  return request({
    url: "/v1.0/iwrs/subject/fall_off/all",
    method: "get",
    params: query
  });
}

// 脱落
export function fallOff(data) {
  return request({
    url: "/v1.0/iwrs/subject/fall_off/add",
    method: "post",
    data
  });
}

// 一级揭盲人
export function one(data) {
  return request({
    url: "/v1.0/iwrs/unblind/one",
    method: "post",
    data
  });
}

// 一级盲底列表，分页
export function onePage(query) {
  return request({
    url: "/v1.0/iwrs/unblind/one_bottom",
    method: "get",
    params: query
  });
}

// 二级揭盲人
export function two(data) {
  return request({
    url: "/v1.0/iwrs/unblind/two",
    method: "post",
    data
  });
}

// 二级盲底列表，分页
export function twoPage(query) {
  return request({
    url: "/v1.0/iwrs/unblind/two_bottom",
    method: "get",
    params: query
  });
}

// 紧急揭盲
export function urgent(data) {
  return request({
    url: "/v1.0/iwrs/subject/urgently_unblind/add",
    method: "post",
    data
  });
}

// 所有紧急揭盲的受试者，分页
export function unblindPage(query) {
  return request({
    url: "/v1.0/iwrs/subject/urgently_unblind/all",
    method: "get",
    params: query
  });
}

// 详情，获取最近备注也调用这个接口
export function detail(query) {
  return request({
    url: "/v1.0/iwrs/subject/detail",
    method: "get",
    params: query
  });
}

// 备注
export function remarks(data) {
  return request({
    url: "/v1.0/iwrs/subject/remarks",
    method: "post",
    data
  });
}

// 变更访视
export function nextView(data) {
  return request({
    url: "/v1.0/iwrs/subject/go_next_visit",
    method: "post",
    data
  });
}

// 查看（访视变更记录）
export function logs(query) {
  return request({
    url: "/v1.0/iwrs/subject/logs",
    method: "get",
    params: query
  });
}

// 导出
export function exportFile(data) {
  return request({
    url: "/v1.0/iwrs/subject/export",
    method: "post",
    data,
    responseType: "blob"
  });
}

// 揭盲记录列表
export function list(query) {
  return request({
    url: "/v1.0/iwrs/unblind/list",
    method: "get",
    params: query
  });
}

// 新增受试者时根据选择的单位获取前缀和后缀
export function nextInfor(data) {
  return request({
    url: "/v1.0/iwrs/subject/next_infor",
    method: "post",
    data
  });
}
// 受试者-登记信息导出
export function exportSubjectIndoFn(data) {
  return request({
    url: "/v1.0/iwrs/subject/export",
    method: "post",
    data,
    responseType: "blob"
  });
}

// 受试者-登记信息导出
export function subjectSetting(data) {
  return request({
    url: "/v1.0/iwrs/project/set/subject",
    method: "post",
    data
  });
}

// 获取项目所有版本
export function getEDCProjectVersion(params) {
  return request({
    url: "/v1.0/iwrs/edc_synchro/project_version/all_no_page",
    method: "get",
    params
  });
}

// 确认登记
export function subjectUpdate(data) {
  return request({
    url: "/v1.0/iwrs/subject/update",
    method: "put",
    data
  });
}

// 编辑受试者
export function subjectEdit(data) {
  return request({
    url: "/v1.0/iwrs/subject/update_special",
    method: "put",
    data
  });
}
